// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageApp_loading__129Ac","fadein":"PageApp_fadein__2B4Ov","spinner":"PageApp_spinner__2dlHA","message":"PageApp_message__a4EfO"};